module.exports = __webpack_public_path__ + "img/rss-fill.330af64c.svg";